<section>
  <div
    class="flex flex-col items-center justify-center m-3 px-2 text-blue text-14"
  >
    <div class="flex items-center mb-6">
      <img
        class="w-[125px] object-contain"
        [src]="urlIMG + 'logo-red.png'"
        alt="marcadores logo"
      />
    </div>

    <div class="w-full my-2">
      <div class="space-y-6 font-roboto-400 text-blue text-14 max-sm:text-12">
        <h1
          [class.dark-mode]="themeService.getCurrentTheme() === 'dark'"
          class="text-center text-blue-important text-18 max-sm:text-14 font-roboto-500"
        >
          {{
            (isMail === "FORGOTPASSWORD"
              ? "Enter your email and we'll send you a link to reset your password."
              : isMail === "SIGNUP"
              ? "Register new Account"
              : "Sign In to your account"
            ) | translate
          }}
        </h1>

        <nz-alert
          class="w-full"
          *ngIf="errorMessage"
          [nzShowIcon]="true"
          nzType="error"
          [nzMessage]="errorMessage"
        ></nz-alert>

        <nz-spin [nzSpinning]="loader">
          <div class="space-y-6">
            <form
              class="space-y-6"
              [formGroup]="profileForm"
              (ngSubmit)="
                isMail === 'FORGOTPASSWORD'
                  ? forgotPassword()
                  : isMail === 'SIGNIN'
                  ? signIn('EMAIL')
                  : register()
              "
              *ngIf="isMail"
            >
              <div>
                <input
                  class="text-black bg-gray-50 border border-grey-14 sm:text-sm rounded-[4px] block w-full p-2.5"
                  placeholder="Email"
                  formControlName="email"
                />
                <div class="text-red-2 mt-1">
                  <span *ngIf="f.email.touched && f.email.errors?.['email']">{{
                    "Invalid email format" | translate
                  }}</span>

                  <span
                    *ngIf="f.email.touched && f.email.errors?.['required']"
                    >{{ "Email is required" | translate }}</span
                  >
                </div>
              </div>

              <div *ngIf="isMail !== 'FORGOTPASSWORD'">
                <input
                  type="password"
                  placeholder="Password"
                  formControlName="password"
                  class="text-black bg-gray-50 border border-grey-14 sm:text-sm rounded-[4px] block w-full p-2.5"
                />
                <div class="text-red-2 mt-1">
                  <span
                    *ngIf="f.password.touched && f.password.errors?.['required']"
                  >
                    {{ "Password is required" | translate }}
                  </span>
                  <span
                    *ngIf="f.password.touched && f.password.errors?.['minlength']"
                  >
                    {{
                      "Password must be at least 6 characters long" | translate
                    }}
                  </span>
                </div>
              </div>

              <div *ngIf="isMail === 'SIGNUP'">
                <input
                  type="password"
                  placeholder="Confirm Password"
                  formControlName="confirmPassword"
                  class="text-black bg-gray-50 border border-grey-14 sm:text-sm rounded-[4px] block w-full p-2.5"
                />
                <div class="text-red-2 mt-1">
                  <span
                    *ngIf="formErrors?.['passwordsMismatch']"
                    class="text-red-2 text-center"
                  >
                    {{
                      "Password and Confirm Password do not match" | translate
                    }}
                  </span>
                </div>
              </div>

              <div
                (click)="changeMailForm('FORGOTPASSWORD')"
                class="text-end hover:underline cursor-pointer text-[#000] hover:text-[#4986c0]"
                *ngIf="isMail === 'SIGNIN'"
              >
                {{ "Forgot your password?" | translate }}
              </div>
              <!-- Terms and Checkboxes (Only in SIGNUP) -->
              <div *ngIf="isMail === 'SIGNUP'" class="space-y-2">
                <div class="flex items-center">
                  <input
                    type="checkbox"
                    formControlName="termsAndConditions"
                    id="terms"
                  />

                  <label
                    for="terms"
                    class="ml-2 text-[#000]"
                    [innerHTML]="
                      'I have read and accept the Terms and Conditions'
                        | translate
                    "
                  ></label>
                </div>

                <div class="text-red-2 mt-1">
                  <span
                    class="text-[#000]"
                    *ngIf="f.termsAndConditions.touched && f.termsAndConditions.errors?.['required']"
                  >
                    {{ "You must accept the Terms and Conditions" | translate }}
                  </span>
                </div>

                <div class="flex items-center">
                  <input
                    type="checkbox"
                    formControlName="privacyPolicy"
                    id="privacy"
                  />

                  <label
                    for="privacy"
                    class="ml-2 text-[#000]"
                    [innerHTML]="
                      'I have read and accept the Privacy Policy' | translate
                    "
                  ></label>
                </div>

                <div class="text-red-2 mt-1">
                  <span
                    class="text-[#000]"
                    *ngIf="f.privacyPolicy.touched && f.privacyPolicy.errors?.['required']"
                  >
                    {{ "You must accept the Privacy Policy" | translate }}
                  </span>
                </div>

                <div class="flex items-center">
                  <input
                    type="checkbox"
                    formControlName="communicationsConsent"
                    id="communications"
                  />

                  <label
                    for="communications"
                    class="ml-2 text-[#000]"
                    [innerHTML]="
                      'I agree to receive commercial and promotional communications from Marcadores Deportivos Del Peru'
                        | translate
                    "
                  ></label>
                </div>

                <div class="flex items-center">
                  <input
                    type="checkbox"
                    formControlName="dataProcessingConsent"
                    id="dataProcessing"
                  />

                  <label
                    for="dataProcessing"
                    class="ml-2 text-[#000]"
                    [innerHTML]="
                      'I authorize the processing of my personal data for personalized content and advertisements'
                        | translate
                    "
                  ></label>
                </div>
              </div>

              <button
                class="text-white bg-red-2 py-3 px-4 rounded-5 w-full hover:shadow-md font-roboto-500"
                type="submit"
              >
                {{
                  (isMail === "FORGOTPASSWORD"
                    ? "SEND"
                    : isMail === "SIGNIN"
                    ? "SIGN IN"
                    : "REGISTER"
                  ) | translate
                }}
              </button>

              <!-- [class.dark-mode]="themeService.getCurrentTheme() === 'dark'" -->
              <p
                class="text-end text-[#000]-important cursor-pointer hover:underline hover:text-[#4986c0]"
                *ngIf="isMail === 'FORGOTPASSWORD'"
                (click)="changeMailForm('SIGNIN')"
              >
                {{ "Go Back" | translate }}
              </p>

              <ng-container *ngIf="isMail === 'SIGNIN'">
                <p
                  [class.dark-mode]="themeService.getCurrentTheme() === 'dark'"
                  class="text-center"
                >
                  {{
                    "Don't have an account? What are you waiting for!"
                      | translate
                  }}
                </p>
                <button
                  class="text-white bg-black py-3 px-4 rounded-5 w-full hover:shadow-md font-roboto-500"
                  (click)="changeMailForm('SIGNUP')"
                >
                  {{ "REGISTER HERE" | translate }}
                </button>
              </ng-container>

              <!-- <p class="text-center" *ngIf="isMail === 'SIGNUP'">
                Already a memeber?
                <span
                  class="hover:underline cursor-pointer hover:text-[#4986c0]"
                  (click)="changeMailForm('SIGNIN')"
                >
                  Sign In
                </span>
              </p> -->
            </form>

            <button
              *ngIf="!isMail"
              (click)="changeMailForm('SIGNIN')"
              class="flex items-center justify-center gap-3 bg-white shadow-md border border-grey-5 py-2 px-4 rounded-5 w-full hover:shadow-lg"
            >
              <img
                class="w-[30px] cursor-pointer"
                [src]="urlIcon + 'email.png'"
                alt="email"
              />
              {{ "Sign in with" | translate }} Email
            </button>

            <ng-container *ngIf="isMail !== 'FORGOTPASSWORD'">
              <div class="flex justify-center gap-4" *ngIf="isMail !== null">
                <img
                  class="w-[30px] cursor-pointer"
                  [src]="urlIcon + 'google.svg'"
                  alt="google"
                  (click)="signIn('GOOGLE')"
                />
                <img
                  class="w-[30px] cursor-pointer"
                  [src]="urlIcon + 'apple.svg'"
                  alt="apple"
                  (click)="signIn('APPLE')"
                />
              </div>

              <ng-container *ngIf="isMail === null">
                <hr class="border-grey-4" />
                <button
                  class="flex items-center justify-center gap-3 bg-white shadow-md border border-grey-5 py-2 px-4 rounded-5 w-full hover:shadow-lg"
                  (click)="signIn('GOOGLE')"
                >
                  <img
                    class="w-[30px] cursor-pointer"
                    [src]="urlIcon + 'google.svg'"
                    alt="google"
                  />
                  {{ "Sign in with" | translate }} Google
                </button>
                <button
                  class="flex items-center justify-center gap-3 bg-white shadow-md border border-grey-5 py-2 px-4 rounded-5 w-full hover:shadow-lg"
                  (click)="signIn('APPLE')"
                >
                  <img
                    class="w-[30px] cursor-pointer"
                    [src]="urlIcon + 'apple.svg'"
                    alt="apple"
                  />
                  {{ "Sign in with" | translate }} Apple
                </button>
              </ng-container>
              <!-- <button
                class="flex items-center justify-center gap-3 bg-white shadow-md border border-grey-5 py-2 px-4 rounded-5 w-full hover:shadow-lg"
                (click)="signIn('FACEBOOK')"
              >
                <img
                  class="w-[32px] cursor-pointer"
                  (click)="signIn('FACEBOOK')"
                  [src]="urlIcon + 'fb.svg'"
                  alt="facebook"
                />
                {{"Sign in with" | translate}} Facebook
              </button> -->
            </ng-container>
          </div>
        </nz-spin>
      </div>
    </div>
  </div>
</section>
